"use client";

import { VimeoBackground } from "@/components/Video/VimeoBackground";
import css from "./haptic-card.module.scss";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { VideoBackground } from "@/components/Video/VideoBackground";

interface HapticFeedbackCardClientProps {
  cardRef: React.RefObject<HTMLDivElement | null>;
}

const HapticFeedbackCardClient = React.memo<HapticFeedbackCardClientProps>(({ cardRef }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState<boolean>(false);
  const isMountedRef = useRef<boolean>(true);

  const handleVideoStarted = useCallback(() => {
    if (isMountedRef.current) {
      setIsVideoLoaded(true);
    }
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    const card = cardRef.current;
    
    return () => {
      isMountedRef.current = false;
      if (card) {
        card.classList.remove(css.vibrationAnimation);
      }
    };
  }, [cardRef]);

  useEffect(() => {
    if (!isVideoLoaded || !isMountedRef.current) return;

    const card = cardRef.current;
    if (card) {
      void card.offsetWidth;
      card.classList.add(css.vibrationAnimation);
    }

    return () => {
      if (card) {
        card.classList.remove(css.vibrationAnimation);
      }
    };
  }, [isVideoLoaded, cardRef]);

  return (
    <div className="absolute w-full h-full z-[1] rounded-default overflow-hidden">
      <div className="w-full h-full pl-[2px]">
        <VideoBackground videoSrc="" />
        <VimeoBackground
          videoId={1126939899}
          onVideoStarted={handleVideoStarted}
          className="max-md:top-full max-md:-translate-y-[50%]"
        />
      </div>
    </div>
  );
});

HapticFeedbackCardClient.displayName = 'HapticFeedbackCardClient';

export default HapticFeedbackCardClient;
